import { ChangePasswordRequest, LoginCredentials } from '../types/requests/auth.requests';
import { LoginResponse, UserResponse } from '../types/responses/auth.responses';
import {
    RevokeOtherSessionsResponse,
    RevokeSessionResponse,
    SessionsResponse,
} from '../types/responses/session.responses';
import { UserSession } from '../types/entities/session.entity';
import { User } from '../types/entities/user.entity';
import { api, removeAuthToken } from './client';

export const authService = {
    async login(credentials: LoginCredentials): Promise<string> {
        const response = await api.post<LoginResponse>('/login', credentials);
        return response.data.data.accessToken;
    },

    async getMe(): Promise<User> {
        const response = await api.get<UserResponse>('/user');
        return response.data.data;
    },

    async changePassword(payload: ChangePasswordRequest): Promise<void> {
        await api.put('/user/password', payload);
    },

    async getSessions(): Promise<UserSession[]> {
        const response = await api.get<SessionsResponse>('/user/sessions');
        return response.data.data.sessions;
    },

    async revokeSession(id: string): Promise<boolean> {
        const response = await api.delete<RevokeSessionResponse>(`/user/sessions/${id}`);
        return response.data.data.revoked_current;
    },

    async revokeOtherSessions(): Promise<number> {
        const response = await api.delete<RevokeOtherSessionsResponse>('/user/sessions/others');
        return response.data.data.revoked_count;
    },

    logout: async () => {
        try {
            await api.post('/logout');
        } catch (err) {
            // Best-effort: still clear local token if server is unreachable
        }
        removeAuthToken();
    }
};
